<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-09 14:10:40
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-09 14:29:01
 * @FilePath: \vue-privilege-routing\src\pages\website\websiteInvest.vue
-->
<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-09 13:52:54
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-09 14:10:35
 * @FilePath: \vue-privilege-routing\src\pages\website\websiteAdvice.vue
-->
<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-09 12:59:49
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-09 13:48:40
 * @FilePath: \vue-privilege-routing\src\pages\website\website.vue
-->

<template>
  <div id="login_wrap">
    <div class="website-tabs">
      <div class="box">
        <h1>
          <!-- <img src="../assets/logo.png"> -->
          <span>Aubuary</span>
        </h1>
        <nav>
          <router-link active-class="active" class="active_first" to="/website">首页</router-link>
          <router-link active-class="active" to="/websiteAdvice">方案咨询</router-link>
          <!-- 免费咨询      付费资询     战略规划 -->
          <router-link active-class="active" to="/websiteCustomize">企业定制</router-link>
          <!-- 小程序开发    网站开发     APP开发    -->
          <router-link active-class="active" to="/websiteTechnology">技术服务</router-link>
          <!--  SaaS服务    开放接口     技术购买   技术支持   技术外包-->
          <router-link active-class="active" to="/websiteCompany">关于我们</router-link>
          <!--  活在当下    寻求突破     畅想未来    诗和远方 -->
          <router-link active-class="active" to="/websiteInvest">投资加盟</router-link>
          <!-- 深蓝(发动机简笔当图标)学院    定制服务    技术服务 -->
        </nav>
      </div>
    </div>
    <div class="website-content">
      <span>直来直去,说吧,你想投多少</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { doLogin, checkLogin, registerSubmit } from '../../api'

export default {
  data() {
    return {
      websiteForm: {
        mobileNum: '',
        verifyCode: ''
      },
      rules: {},
      loading: ''
    }
  },
  methods: {},
  mounted() {}
}
</script>
<style scoped lang="scss">
#login_wrap {
  position: relative;
  background-image: url('../../assets/website_back.png');
  background-size: cover;
  display: flex;
  flex-wrap: wrap;
  h1 {
    color: white;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
  }
  span {
    text-align: center;
    font-size: 30px;
    color: white;
  }
}
.website-tabs {
  // background-color: red;
  height: 12%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.website-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  
     
}

/* ---  banner样式开始  --- */
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  color: #ffffff;
}
.box {
  display: flex;
  align-items: center;
}
h1 {
  display: flex;
  align-items: center;
  font: normal 28px Cookie, Arial, Helvetica, sans-serif;
  padding: 0px 20px;
}
img {
  width: 40px;
  height: 40px;
}

nav {
  display: flex;
  align-items: center;
  margin: 0px 40px;
  font: 16px Arial, Helvetica, sans-serif;
}
nav a {
  padding: 0 15px;
  width: 150px;
  text-decoration: none;
  color: #ffffff;
  font-size: 24px;
  font-weight: normal;
  opacity: 0.9;
}

nav a:hover {
  opacity: 1;
}

.active {
  color: #608bd2;
  pointer-events: none;
  opacity: 1;
}
.active-first {
  text-align: center;
}

/* ---  banner样式结束  --- */


</style>
